// 基准大小
const baseSize = 20
// 设计稿宽度
const designWidth = 320

// 检测是否为移动设备（包括手机和平板）
function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // 检测移动设备的关键词（手机和平板都走rem适配）
  const mobileKeywords = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Mobile/i,
    /Tablet/i,
    /Samsung/i,
    /Huawei/i,
    /Xiaomi/i,
    /OPPO/i,
    /vivo/i,
    /OnePlus/i,
  ]

  // 额外检测平板设备特征
  const isTablet = /iPad|Android.*Tablet|Windows.*Touch|Kindle|Silk|PlayBook/i.test(userAgent)

  return mobileKeywords.some(keyword => keyword.test(userAgent)) || isTablet
}

// 设置 rem 函数
function setRem() {
  const clientWidth = document.documentElement.clientWidth

  // 只有真正的PC桌面端（宽度>750px且不是移动设备）才不做rem转换
  // 手机、平板（包括iPad、Android平板）都继续使用rem适配
  // todo 统一处理逻辑
  // if (clientWidth > 750 && !isMobileDevice()) {
  //   document.documentElement.style.fontSize = baseSize + 'px'
  //   return
  // }

  // 移动端、平板、小屏幕：继续rem适配
  // 当前页面宽度相对于设计稿宽度的缩放比例
  const scale = clientWidth / designWidth
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}

// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.addEventListener('resize', setRem)
// 页面显示时重新设置 rem
window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    setRem()
  }
})

// 兼容特殊机型
document.addEventListener('DOMContentLoaded', setRem)

// 导出rem计算函数，方便在js中使用
export function getRem() {
  return parseFloat(window.getComputedStyle(document.documentElement).fontSize)
}

// 导出px转rem函数
export function px2rem(px) {
  return px / baseSize
}

// 导出rem转px函数
export function rem2px(rem) {
  return rem * baseSize
}

// 导出设备检测函数
export { isMobileDevice }
